import { render } from "./postForm.vue?vue&type=template&id=61ec6c33&scoped=true"
import script from "./postForm.vue?vue&type=script&lang=js"
export * from "./postForm.vue?vue&type=script&lang=js"

import "./postForm.vue?vue&type=style&index=0&id=61ec6c33&scoped=true&lang=css"
import "./postForm.vue?vue&type=style&index=1&id=61ec6c33&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec6c33"]])

export default __exports__